/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import axios from "axios";
import { set } from "./../../utils/lodash-utils";

import { getResponse } from "./mockData";
import config from "./../config";

const url = `${config.basename}/api/v1/navigation-menu`;
class UserNavigation {
  constructor() {
    this.transformToUIObject = this.transformToUIObject.bind(this);
    this.formObject = this.formObject.bind(this);
  }

  async get() {
    if (process.env.NODE_ENV == "development") {
      return new Promise((resolve) => {
        resolve({
          data: this.transformToUIObject(getResponse),
        });
      });
    }
    const response = await axios.get([url, "menu"].join("/"));
    return {
      data: this.transformToUIObject(response.data),
    };
  }

  transformToUIObject(data) {
    const object = data.reduce((o, { menuPath, menuId, type, ...rest }) => {
      let menuPathTemp = menuPath.replaceAll("/", ".");
      if (type === "custompage") {
        menuPathTemp = "My Dashboards." + menuPathTemp;
      }

      return set(o, menuPathTemp, {
        isEndNode: true,
        menuPath,
        menuId,
        type,
        meta: rest,
      });
    }, {});

    return this.formObject(object);
  }

  formObject(object) {
    return Object.entries(object).map((item) => {
      if (item[1].isEndNode) {
        return {
          id: item[1].menuId,
          key: item[1].menuId,
          title: item[1].menuPath.split("/").pop(),
          path: item[1].menuPath,
          type: item[1].type,
          meta: item[1].meta,
          isEndNode: true,
        };
      } else {
        const formedObj = this.formObject(item[1]);
        return {
          id: item[0],
          key: item[0],
          title: item[0],
          type: item[1].type,
          path: item[0],
          meta: formedObj,
          children: formedObj,
          isEndNode: false,
        };
      }
    });
  }
}

const userNavigation = new UserNavigation();
export default userNavigation;
